import React, { useMemo, Suspense } from 'react';

import Spinner from 'components/spinner';

import { lazyImport } from 'services/lazy-service';

const LazyComponent = ({ fallback, children, importFn, componentProps }) => {
    const Component = useMemo(() => {
        return importFn && lazyImport(importFn);
    }, [importFn]);

    return (
        <Suspense fallback={fallback}>
            { children || <Component {...componentProps} /> }
        </Suspense>
    );
}

LazyComponent.defaultProps = {
    fallback: <Spinner centered={true} />
}

export default React.memo(LazyComponent);
